export let AccountingStatus = /*#__PURE__*/function (AccountingStatus) {
  AccountingStatus["Success"] = "success";
  AccountingStatus["RequestTimeout"] = "request-timeout";
  return AccountingStatus;
}({});
export let AccountingItemType = /*#__PURE__*/function (AccountingItemType) {
  AccountingItemType["Service"] = "service";
  AccountingItemType["Bundle"] = "bundle";
  return AccountingItemType;
}({});